// extracted by mini-css-extract-plugin
export default {"subQuestionsButtonContainer":"SubQuestions_subQuestionsButtonContainer__+P9VD"};